// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HistoryModal_wrapper__1er6A"};